import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../../components/header/header.component';
import { FooterComponent } from '../../../components/footer/footer.component';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthServiceService } from '@services/auth-service.service';
import { LoaderService } from '@services/loader.service';
import { Globals } from 'src/app/globals';
import { AlertController } from '@ionic/angular';
import { RegUser } from '../../basic-reg/RegUser';

import { ModalController } from '@ionic/angular';
import { ContactSettingComponent } from '@modal/contact-setting/contact-setting.component';


@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    HeaderComponent,
    FooterComponent
  ]
})
export class ProfileDetailsComponent implements OnInit {
  ownerId!: number;
  user: any;
  userForm: RegUser = new RegUser();
  currentUser: RegUser = new RegUser();
  editEnabled: boolean = false;
  contactAdded: boolean = false;
  addEnabled: boolean = false;
  isSearchResult: boolean = false;
  viewTimeSlot: boolean = false;
  errorMessage: string = '';
  requestPath: string;

  contactId!: number;
  contactCategory: string = 'friends';
  contactTimePreference: any;
  userContact: any;

  constructor(public global: Globals,
    private location: Location,
    public router: Router,
    public authService: AuthServiceService,
    private loader: LoaderService,
    public modlCtrl: ModalController,
    public atrCtrl: AlertController) {
    this.requestPath = this.global.requestPath;
  }

  ngOnInit() {
    const nav = this.router.getCurrentNavigation();
    const state = nav && nav.extras && nav.extras.state ? nav.extras.state : {};
    if (this.global.isEmpty(state)) {
      this.router.navigate(['dashboard']);
      return;
    }
    this.editEnabled = state['editEnabled'] ?? false;
    this.addEnabled = state['addEnabled'] ?? false;
    this.user = state['user'] ?? null;
    this.isSearchResult = state['isSearchResult'] ?? false;
    this.userContact = state['userContact'] ?? null;
    this.viewTimeSlot = state['viewTimeSlot'] ?? false;
  }

  ionViewDidEnter() {
    this.ownerId = this.authService.getLoggedInUser().id ?? 0;
    this.currentUser = this.authService.getLoggedInUser();
    this.currentUser.imageUrl = this.authService.getProfilePicture() as string;
  }

  goBack() {
    this.location.back();
  }

  goTo(link: string) {
    this.router.navigateByUrl(link)
  }

  async openSettingModal() {
    const modal = await this.modlCtrl.create({
      component: ContactSettingComponent,
      componentProps: {
        user: this.userContact,
        personalizedMsg: this.userContact.personalizedMsg,
        isSender: false,
        isAddButtonVisible: false,
        viewMode: true
      }
    });

    modal.onDidDismiss().then((dataReturned) => {
      // this.router.navigateByUrl("dashboard");
    });

    modal.present();
  }
}
